import * as React from 'react';
import ReactDatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { Icon } from '@teamsnap/teamsnap-ui';
import './date-picker.scss';

export interface Props {
  name: string;
  className: string;
  dateProps: any;
  disabled: boolean;
  inputRef: React.RefObject<any>;
  useHookResponse: any;
  placeholderText?: string;
}

export default class DatePicker extends React.PureComponent<Props> {
  static defaultProps: { placeholderText: string };

  render() {
    const { dateProps, className, placeholderText, disabled, inputRef, useHookResponse, name } = this.props;
    const { control } = useHookResponse;
    return (
      <div className="date-picker">
        <Controller
          // @ts-ignore
          as={ReactDatePicker}
          control={control}
          valueName="selected" // DateSelect value's name is selected
          onChange={([selected]) => selected}
          name={name}
          showMonthDropdown
          showYearDropdown
          minDate={dateProps?.minDate}
          maxDate={dateProps?.maxDate}
          className={className}
          placeholderText={placeholderText}
        />
        <div className="calendar">
          <Icon name="schedule" />
        </div>
      </div>
    );
  }
}

DatePicker.defaultProps = {
  placeholderText: 'Select date',
};
